module.exports = __webpack_public_path__ + "static/media/checklist.ba253d20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/checklist.svg
// module id = 612
// module chunks = 0